<div class="d-flex flex-column h-100">
  <lib-dialog-header (closeClick)="closeClicked()" i18n> Filters </lib-dialog-header>
  <div class="panel-content">
    @if (tabs().length > 1) {
      <lib-tab-group class="d-block mb-3" [tabs]="tabs()" (indexSelected)="selectedGroupIndex.set($event)">
      </lib-tab-group>
    }
    <div class="filters-container">
      @for (tableFilter of selectedGroup().filters; track $index) {
        @if (tableFilter.type === TableFilterType.pillSelection) {
          <lib-pill-selection-filter [tableFilter]="tableFilter"></lib-pill-selection-filter>
        }
        @if (tableFilter.type === TableFilterType.radio) {
          <lib-radio-filter [tableFilter]="tableFilter"></lib-radio-filter>
        }
        @if (tableFilter.type === TableFilterType.checkbox) {
          <lib-checkbox-filter [tableFilter]="tableFilter"></lib-checkbox-filter>
        }
        @if (tableFilter.type === TableFilterType.typeAhead) {
          <lib-typeahead-filter [tableFilter]="tableFilter"></lib-typeahead-filter>
        }
        @if (tableFilter.type === TableFilterType.numeric) {
          <lib-numeric-filter [tableFilter]="tableFilter"></lib-numeric-filter>
        }
        @if (tableFilter.type === TableFilterType.date || tableFilter.type === TableFilterType.dateOnly) {
          <lib-date-filter [tableFilter]="tableFilter"></lib-date-filter>
        }
      }
    </div>
  </div>
  <div class="dialog-footer">
    <lib-button [type]="ButtonType.secondary" (buttonClick)="resetAllClicked()" i18n> Reset All </lib-button>
    <lib-button [type]="ButtonType.primary" (buttonClick)="updateFiltersClicked()" i18n> Update Filters </lib-button>
  </div>
</div>
